const OfferWall = () => import("./OfferWall.vue");
const OfferWallBanner = () => import("./OfferWallBanner.vue");
const OfferWallv2 = () => import("./OfferWallv2.vue");

export const OfferWallRoutes = [
  {
    path: "/tc-offerwall",
    component: OfferWall,
    meta: {
      title: "Truecaller Brand Hub"
    }
  },
  {
    path: "/tc-offerwall-banner",
    component: OfferWallBanner,
    meta: {
      title: "Truecaller Brand Hub"
    }
  },
  {
    path: "/tc-offerwallv2",
    component: OfferWallv2,
    meta: {
      title: "Truecaller Brand Hub"
    }
  }
];
